<template>
  <div>

    <!-- Metadados -->
    <sp-360-panel :title="$t('management.dados.painelDAGS')" :footerComplementar="$t('management.dados.listaFooter')">
      <div class="flex">
        <div class="row" style="margin-top:2rem;">
            <sp360-data-table id="tabelaServicosPorOrgao" ref="tabelaServicosPorOrgao" :apiMode="false"
            :data="tabelaDados.data" :fields="tabelaDados.campos"
            :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage"
            @editarRow="editar($event)"/>
        </div>

      </div>
    </sp-360-panel>

    <!-- Cargas e Cache -->
    <div class="row">
      <div class="flex lg6"> <!-- Cargas de Dados -->
        <div class="row flex">
          <sp-360-panel  fit :title="$t('management.dados.painelCargas')" :footerComplementar="$t('management.dados.listaFooter')" style="height:58.5rem">
            <div class="listaCache">
              <sp360-data-table id="tabelaServicosPorOrgao" ref="tabelaServicosPorOrgao" :apiMode="false"
                :data="tabela.data" :fields="tabela.campos"
                :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage"
                @editarRow="editarCarga($event)" />
            </div>
          </sp-360-panel>
        </div>
      </div>
      <div class="flex lg6">
        <sp360-list fit :title="$t('management.dados.painelCache')" :footerComplementar="$t('management.dados.listaFooter')" >
          <div style="padding-bottom: 2em">
            <va-button type="button"  @click="cacheModal()" color="danger" outline small class="pull-right" >
              {{'Limpar todo Cache'| translate}}
            </va-button>
            <br>
          </div>
          <div class="listaCache">
              <template v-for="(f, index) in cacheList" class="">
                <va-item>
                  <va-item-section>
                    <va-item-label>
                      <a class="bold">{{index}}</a> : {{f.nome}}
                      <va-button type="button"  @click="limparCache(f.nome)" color="danger" outline small class="pull-right" icon="fa fa-trash">
                      </va-button>
                    </va-item-label>
                    <div v-for="(a, index) in f.chaves">
                      <va-item-label caption>
                        {{a}}
                      </va-item-label>
                    </div>
                  </va-item-section>
                </va-item>
                <va-list-separator v-if="index < cacheList.length-1 " />
              </template>
          </div>
        </sp360-list>
      </div>
    </div>

    <!-- Edição e Adição -->
    <div class="row ">
      <div class="flex lg3 md12 sm12">  <!-- Lista Distribuicao -->
        <sp-360-panel  fit :title="$t('management.dados.painelDistribuicao')" :footerComplementar="$t('management.dados.listaFooter')" >
          <div class="row">
            <div class="flex lg8">
              <label class="multiselect__label">{{$t('management.dados.selectLabel.distribuicao')}}</label>
              <multiselect
                id="selectmeiosDistribuicao"
                name="meiosDistribuicao"
                :placeholder="$t('management.dados.meio_distribuicaoSelect')"
                :value="distribuicaoEditavel"
                :options="meiosDistribuicao"
                v-model="distribuicaoEditavel"
                track-by="meio_distribuicao"
                label="meio_distribuicao"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :allowEmpty="false"
                :selectLabel="$t('menu.multiselect')"
                :selectGroupLabel="$t('menu.multigroupselect')"
                :deselectLabel="$t('menu.multideselect')"
                :deselectGroupLabel="$t('menu.multigroupdeselect')"
                />
              </div>
            <div class="flex lg4 pull-right baseline-align" >
              <va-button @click="editarDistribuicao(distribuicaoEditavel)" color="warning" icon="fa fa-pencil" ></va-button>
              <va-button @click="editarDistribuicao()" color="success" icon="fa fa-plus" ></va-button>
            </div>
          </div>
          <div class="listaEdit">
            <template v-for="(f, index) in meiosDistribuicao" class="">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    <a class="bold">{{f.id}}</a> : {{f.meio_distribuicao}}
                    <va-button type="button"  @click="editarDistribuicao(f)" color="warning" outline small class="pull-right" icon="fa fa-pencil">
                    </va-button>
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < meiosDistribuicao.length-1 " />
            </template>
          </div>
        </sp-360-panel>
      </div>

      <div class="flex lg3 md12 sm12"> <!-- Lista Representacao -->
        <sp-360-panel  fit :title="$t('management.dados.painelRepresentacao')" :footerComplementar="$t('management.dados.listaFooter')" >
          <div class="row">
            <div class="flex lg8">
                <label class="multiselect__label">{{$t('management.dados.selectLabel.representacao')}}</label>
                <multiselect
                id="selectMeioRepresentacao"
                name="meiosRepresentacao"
                :placeholder="$t('management.dados.meio_representacaoSelect')"
                :value="representacaoEditavel"
                :options="meiosRepresentacao"
                v-model="representacaoEditavel"
                track-by="meio_representacao"
                label="meio_representacao"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :allowEmpty="false"
                :selectLabel="$t('menu.multiselect')"
                :selectGroupLabel="$t('menu.multigroupselect')"
                :deselectLabel="$t('menu.multideselect')"
                :deselectGroupLabel="$t('menu.multigroupdeselect')"
                />
            </div>
            <div class="flex lg4 pull-right baseline-align">
              <va-button @click="editarRepresentacao(representacaoEditavel)" color="warning" icon="fa fa-pencil"/>
              <va-button @click="editarRepresentacao()" color="success" icon="fa fa-plus"></va-button>
            </div>
          </div>
          <div class="listaEdit">
            <template v-for="(f, index) in meiosRepresentacao" class="">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    <va-button type="button"  @click="editarRepresentacao(f)" color="warning" outline small class="pull-right" icon="fa fa-pencil"/>
                    <a class="bold">{{f.id}}</a> : {{f.meio_representacao}}
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < meiosRepresentacao.length-1 " />
            </template>
          </div>
        </sp-360-panel>
      </div>

      <div class="flex lg3 md12 sm12"> <!-- Lista Periodicidade -->
        <sp-360-panel  fit :title="$t('management.dados.painelPeriodicidade')" :footerComplementar="$t('management.dados.listaFooter')" >
          <div class="row">
            <div class="flex lg8">
                <label class="multiselect__label">{{$t('management.dados.selectLabel.periodicidade')}}</label>
                <multiselect
                id="selectPeriodicidade"
                name="periodicidade"
                :placeholder="$t('management.dados.periodicidadeSelect')"
                :value="periodicidadeEditavel"
                :options="periodicidade"
                v-model="periodicidadeEditavel"
                track-by="periodicidade"
                label="periodicidade"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :allowEmpty="false"
                :selectLabel="$t('menu.multiselect')"
                :selectGroupLabel="$t('menu.multigroupselect')"
                :deselectLabel="$t('menu.multideselect')"
                :deselectGroupLabel="$t('menu.multigroupdeselect')"
                />
            </div>
            <div class="flex lg4 pull-right baseline-align" >
              <va-button @click="editarPeriodicidade(periodicidadeEditavel)" color="warning" icon="fa fa-pencil"></va-button>
              <va-button @click="editarPeriodicidade()" color="success" icon="fa fa-plus"></va-button>
            </div>
          </div>
          <div class="listaEdit">
            <template v-for="(f, index) in periodicidade" class="">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    <va-button type="button"  @click="editarPeriodicidade(f)" color="warning" outline small class="pull-right" icon="fa fa-pencil"/>
                    <a class="bold">{{f.id}}</a> : {{f.periodicidade}}
                    </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < periodicidade.length-1 " />
            </template>
          </div>
        </sp-360-panel>
      </div>

      <div class="flex lg3 md12 sm12"> <!-- Lista Orgaos -->
        <sp-360-panel  fit :title="$t('management.dados.painelOrgao')" :footerComplementar="$t('management.dados.listaFooter')">
          <div class="row">
            <div class="flex lg8">
                <label class="multiselect__label">{{$t('management.dados.selectLabel.orgao')}}</label>
                <multiselect
                id="selectOrgao"
                name="Orgaos"
                :placeholder="$t('management.dados.orgaoSelect')"
                :value="orgaoEditavel"
                :options="orgaosResponsaveis"
                v-model="orgaoEditavel"
                track-by="sigla"
                label="sigla"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :allowEmpty="false"
                :selectLabel="$t('menu.multiselect')"
                :selectGroupLabel="$t('menu.multigroupselect')"
                :deselectLabel="$t('menu.multideselect')"
                :deselectGroupLabel="$t('menu.multigroupdeselect')"
                />
            </div>
            <div class="flex lg4 pull-right baseline-align">
              <va-button @click="editarOrgao(orgaoEditavel)" color="warning" icon="fa fa-pencil"/>
              <va-button @click="editarOrgao()" color="success" icon="fa fa-plus"></va-button>
            </div>
          </div>
          <div class="listaEdit">
            <template v-for="(f, index) in orgaosResponsaveis" class="">
              <va-item>
                <va-item-section>
                  <va-item-label>
                    <va-button type="button" @click="editarOrgao(f)" color="warning" outline small class="pull-right" icon="fa fa-pencil"/>
                    <a class="bold">{{f.id}} : </a> <span class=""> {{f.sigla}}</span>
                  </va-item-label>
                  <va-item-label caption>
                    <span class=""> {{f.orgao}}</span>
                  </va-item-label>
                </va-item-section>
              </va-item>
              <va-list-separator v-if="index < orgaosResponsaveis.length-1 " />
            </template>
          </div>
        </sp-360-panel>
      </div>

    </div>

    <!-- Modal -->
    <va-modal ref="cacheModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="limparCache()"
                   @cancel="cancelarDelecao()"
                   :title="'management.dados.modal.titulo.cache' | translate"
                   v-model="openCacheModal"
                   >
      <template slot="default">
        {{'management.dados.cleanCacheConfirmationText' | translate}}
      </template>
    </va-modal>

    <!-- Carga -->
    <va-modal ref="cargaModal"
                   :okText="'management.save' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="persistirCarga()"
                   @cancel="cancelarDelecao()"
                   :title="$t('management.dados.modal.titulo.carga')"
                   v-model="openModalCarga"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="true"
                   >
      <template slot="default">
        <div data-vv-scope="formCarga" class="">
          <fieldset>
            <div class="flex form-group" :class="{'has-error': errors.has('editado.nome') }">
              <!-- inputs -->
              <div class="row">
                <div class="input-group flex sm12">
                  <va-input id="cargaID" name="dag" required v-model="cargaEditavel.id" v-validate="'required'" label="ID" :disabled="true"/>
                </div>
                <div class="input-group flex sm12">
                  <va-input id="dag" name="dag" required v-model="cargaEditavel.nome_dag" v-validate="'required'" label="Nome_dado"/>
                </div>
                <div class="input-group flex sm12">
                  <va-input id="ultimaCarga" name="dag" required v-model="cargaEditavel.data_hora_ultima_carga" v-validate="'required'" label="Ultima Carga" :disabled="true"/>
                </div>
              </div>
              <div class="row">
                <!-- Orgao Responsavel -->
                <div class="input-group flex sm12">
                  <label class="multiselect__label">{{$t('management.dados.selectLabel.orgao')}}</label>
                  <multiselect
                    id="selectorgaosResponsaveis"
                    name="orgaosResponsaveis"
                    :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                    v-model="cargaEditavel.orgao_responsavel"
                    :options="orgaosResponsaveis"
                    track-by="id"
                    label="orgao"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="true"
                    :allowEmpty="false"
                    :selectLabel="$t('menu.multiselect')"
                    :selectGroupLabel="$t('menu.multigroupselect')"
                    :deselectLabel="$t('menu.multideselect')"
                    :deselectGroupLabel="$t('menu.multigroupdeselect')"
                  />
                  <small v-show="errors.has('cargaEditavel.nome_DAG')" class="help text-danger">{{errors.first('editado.unidade')}}</small>
                </div>
                <!-- periodicidade -->
                <div class="input-group flex sm12">
                  <label class="multiselect__label">{{$t('management.dados.selectLabel.periodicidade')}}</label>
                  <multiselect
                    id="selectperiodicidade"
                    name="periodicidade"
                    :placeholder="$t('management.dados.periodicidadeSelect')"
                    v-model="cargaEditavel.periodicidade_carga"
                    :value="cargaEditavel.periodicidade"
                    track-by="id"
                    label="periodicidade"
                    :options="periodicidade"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="true"
                    :allowEmpty="false"
                    :selectLabel="$t('menu.multiselect')"
                    :selectGroupLabel="$t('menu.multigroupselect')"
                    :deselectLabel="$t('menu.multideselect')"
                    :deselectGroupLabel="$t('menu.multigroupdeselect')"
                  />
                  <small v-show="errors.has('editado.unidade')"
                                class="help text-danger">{{
                            errors.first('editado.unidade')
                    }}
                  </small>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </template>
    </va-modal>

    <!-- Orgao -->
    <va-modal ref="orgaoModal"
                   :okText="'management.delete' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="persisirOrgao()"
                   @cancel="cancelarDelecao()"
                   :title="'management.dados.modal.titulo.orgao' | translate"
                   v-model="openModalOrgao"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="true"
                   >
      <template slot="default">
        <div data-vv-scope="formOrgao" class="modalForm">
          <fieldset>
              <div class="row form-group">
                <a class="pull-right">ID: {{ orgaoEditavel.id ? orgaoEditavel.id : ''}}</a>
              </div>
              <br>
              <div class="row form-group" :class="{'has-error': errors.has('orgaoEditavel.orgao') }">
                <div class="input-group flex lg12 md12 sm12">
                  <va-input id="orgao" name="orgao" required v-model="orgaoEditavel.orgao" v-validate="'required'" label="Orgão"/>
                </div>
                <div class="input-group flex lg12 md12 sm12">
                  <va-input id="sigla" name="sigla" required v-model="orgaoEditavel.sigla" v-validate="'required'" label="Sigla"/>
                </div>
              </div>
          </fieldset>
          </div>
      </template>
    </va-modal>

    <!-- Periodicidade -->
    <va-modal ref="periodicidadeModal"
                   :okText="'management.save' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="persisirPeriodicidade()"
                   @cancel="cancelarDelecao()"
                   :title="'management.confirmation' | translate"
                   v-model="openModalPeriodicidade"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="true"
                   >
      <template slot="default">
        <div data-vv-scope="formPeriodicidade" class="modalForm">
          <fieldset>
              <div class="row form-group" >
                <a class="pull-right">ID: {{ periodicidadeEditavel.id ? periodicidadeEditavel.id : ''}}</a>
              </div>
              <br>
              <div class="row form-group" :class="{'has-error': errors.has('periodicidadeEditavel.periodicidade') }">
                <div class="input-group flex lg6 md6 sm12">
                  <va-input id="periodicidade" name="periodicidade" required v-model="periodicidadeEditavel.periodicidade" v-validate="'required'" label="Periodicidade"/>
                </div>
              </div>
          </fieldset>
        </div>
      </template>
    </va-modal>

    <!-- Representacao -->
    <va-modal ref="representacoaModal"
                   :okText="'management.save' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="persisirRepresentacao()"
                   @cancel="cancelarDelecao()"
                   :title="$t('management.dados.modal.titulo.representacao')"
                   v-model="openModalRepresentacao"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="true"
                   >
      <template slot="default">
            <div data-vv-scope="formRepresentacao" class="modalForm">
              <fieldset>
                  <div class="row form-group" >
                    <a class="pull-right">ID: {{ representacaoEditavel.id ? representacaoEditavel.id : ''}}</a>
                  </div>
                  <br>
                  <div class="row form-group" :class="{'has-error': errors.has('representacaoEditavel.meio_representacao') }">
                    <div class="input-group flex lg6 md6 sm12">
                      <va-input id="meio_representacao" name="meio_representacao" required v-model="representacaoEditavel.meio_representacao" v-validate="'required'" label="Meio de representação"/>
                    </div>
                  </div>
              </fieldset>
            </div>
      </template>
    </va-modal>

    <!-- Distribuicao -->
    <va-modal ref="distribuicaoModal"
                   :okText="'management.save' | translate"
                   :cancelText="'management.cancel' | translate"
                   :okClass="'btn btn-primary btn-sm'"
                   :cancelClass="'btn btn-secondary btn-sm'"
                   @ok="persistirDistribuicao()"
                   @cancel="cancelarDelecao()"
                   :title="$t('management.dados.modal.titulo.distribuicao')"
                   v-model="openModalDistribuicao"
                   size="large"
                   maxWidth="100rem"
                   :fixedLayout="true"
                   >
      <template slot="default">
            <div data-vv-scope="formDistribuicao" class="modalForm">
              <fieldset>
                  <div class="row form-group">
                    <a class="pull-right">ID: {{ distribuicaoEditavel.id }}</a>
                  </div>
                  <br>
                  <div class="row form-group" :class="{'has-error': errors.has('distribuicaoEditavel.meio_distribuicao') }">
                    <div class="input-group flex lg6 md6 sm12">
                      <va-input id="nome_distribuicao" name="nome_distribuicao" required v-model="distribuicaoEditavel.meio_distribuicao" v-validate="'required'" label="Meio de distribuição"/>
                    </div>
                  </div>
              </fieldset>
            </div>
      </template>
    </va-modal>

    <!-- METADADOS -->
    <va-modal ref="metadadosModal"
                  :okText="'management.save' | translate"
                  :cancelText="'management.cancel' | translate"
                  :okClass="'btn btn-primary btn-sm'"
                  :cancelClass="'btn btn-secondary btn-sm'"
                  @ok="persistirMetadados()"
                  @cancel="cancelarDelecao()"
                  title="Editar MetaDados"
                  v-model="openModalMetadados"
                  size="large"
                  maxWidth="100rem"
                  :fixedLayout="true"
                  >
            <template slot="default">
              <div class="flex lg12" >
                  <div data-vv-scope="formMetadados" class="formCarga">
                    <fieldset>
                      <div class="row form-group" :class="{'has-error': errors.has('editado.nome') }">
                        <div class="input-group flex sm12">
                          ID: {{editado.id}}
                        </div>

                        <div class="input-group lg6 md6 flex sm12">
                          <va-input id="nome_dado" name="nome_dado" required v-model="editado.nome_dado" v-validate="'required'" label="Nome_dado"/>
                        </div>

                        <div class="input-group lg6 md6 flex sm12">
                          <va-input
                            id="descricao_dado"
                            name="descricao_dado"
                            v-model="editado.descricao_dado"
                            required label="descricao_dado"/>
                        </div>

                        <div class="input-group lg6 md6 flex sm12">
                          <va-input
                            id="local_distribuicao"
                            name="local_distribuicao"
                            v-model="editado.local_distribuicao"
                            required label="local_distribuicao"/>
                        </div>

                        <div class="input-group lg6 md6 flex sm12">
                          <va-input
                            id="fonte_dado"
                            name="fonte_dado"
                            v-model="editado.fonte_dado"
                            required label="fonte_dado"/>
                        </div>

                        <div class="input-group flex lg6 md6 sm12">
                          <label class="multiselect__label">{{$t('management.dados.selectLabel.carga')}}</label>
                          <multiselect
                            id="selectCarga"
                            name="cargas"
                            :placeholder="$t('management.dados.meio_distribuicaoSelect')"
                            v-model="editado.carga"
                            :options="cargas"
                            track-by="id"
                            label="nome_dag"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allowEmpty="false"
                            :selectLabel="$t('menu.multiselect')"
                            :selectGroupLabel="$t('menu.multigroupselect')"
                            :deselectLabel="$t('menu.multideselect')"
                            :deselectGroupLabel="$t('menu.multigroupdeselect')"
                            />
                          <small v-show="errors.has('editado.unidade')" class="help text-danger">
                            {{ errors.first('editado.unidade') }}
                          </small>
                        </div>

                        <div class="input-group flex lg6 md6  sm12">
                          <label class="multiselect__label">{{$t('management.dados.selectLabel.distincao')}}</label>
                          <multiselect
                            id="selectmeiosDistribuicao"
                            name="meiosDistribuicao"
                            :placeholder="$t('management.dados.meio_distribuicaoSelect')"
                            :value="editado.meio_distribuicao"
                            :options="meiosDistribuicao"
                            track-by="id"
                            label="meio_distribuicao"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allowEmpty="false"
                            :selectLabel="$t('menu.multiselect')"
                            :selectGroupLabel="$t('menu.multigroupselect')"
                            :deselectLabel="$t('menu.multideselect')"
                            :deselectGroupLabel="$t('menu.multigroupdeselect')"
                            />
                          <small v-show="errors.has('editado.unidade')" class="help text-danger">
                            {{errors.first('editado.unidade') }}
                          </small>
                        </div>
                        
                        <div class="input-group flex lg6 md6  sm12">
                          <label class="multiselect__label">{{$t('management.dados.selectLabel.representacao')}}</label>
                          <multiselect
                            id="selectmeiosRepresentacao"
                            name="meiosRepresentacao"
                            :placeholder="$t('management.dados.meio_representacaoSelect')"
                            v-model="editado.meio_representacao"
                            :options="meiosRepresentacao"
                            track-by="id"
                            label="meio_representacao"
                            :searchable="false"
                            :close-on-select="true"
                            :show-labels="false"
                            :allowEmpty="false"
                            :selectLabel="$t('menu.multiselect')"
                            :selectGroupLabel="$t('menu.multigroupselect')"
                            :deselectLabel="$t('menu.multideselect')"
                            :deselectGroupLabel="$t('menu.multigroupdeselect')"
                          />

                        <small v-show="errors.has('editado.unidade')"
                                  class="help text-danger">{{
                            errors.first('editado.unidade')
                            }}
                          </small>
                        </div>
                        <div class="input-group flex lg6 md6  sm12">
                          <va-input
                            id="formato_nome"
                            name="formato_nome"
                            v-model="editado.formato_nome"
                            required label="formato_nome"/>
                        </div>
                        <div class="input-group flex lg6 md6  sm12">
                          <va-input
                            id="data_arquivo_ultima_importacao"
                            name="data_arquivo_ultima_importacao"
                            v-model="editado.data_arquivo_ultima_importacao"
                            required label="data_arquivo_ultima_importacao"/>
                        </div>
                        <div class="input-group flex lg6 md6  sm12">
                          <va-input
                            id="data_hora_ultima_importacao"
                            name="data_hora_ultima_importacao"
                            v-model="editado.data_hora_ultima_importacao"
                            required label="data_hora_ultima_importacao"/>
                        </div>
                        <div class="input-group flex lg6 md6  sm12">
                          <va-input
                            id="data_referencia_ultima_importacao"
                            name="data_referencia_ultima_importacao"
                            v-model="editado.data_referencia_ultima_importacao"
                            required label="data_referencia_ultima_importacao"/>
                        </div>
                      </div>
                    </fieldset>
                  </div>
              </div>
            </template>
    </va-modal>

  </div>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import UnidadeService from '@/services/UnidadeService'
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360List from '@/components/ui/list/VaList'

export default {
  components: { Sp360DataTable, Sp360Panel, SpCard, Sp360List, Multiselect },

  computed: {

  },

  data () {
    return {
      editado: {
        carga: {},
        data_arquivo_ultima_importacao: new Date(),
        data_hora_ultima_importacao: new Date(),
        data_referencia_ultima_importacao: new Date(),
        descricao_dado: '',
        fonte_dado: '',
        formato_nome: '',
        id: 0,
        local_distribuicao: '',
        meio_distribuicao: {},
        meio_representacao: {},
        nome_arquivo_ultima_importacao: '',
        nome_dado: '',
        periodicidade_dado: {},
      },

      distribuicaoEditavel: { id: 0, meio_distribuicao: '' },
      representacaoEditavel: { id: 0, meio_representacao: '' },
      periodicidadeEditavel: { id: 0, periodicidade: '' },
      orgaoEditavel: { id: 0, sigla: '', orgao: '' },
      cargaEditavel: { id: 0,
        nome_dag: '',
        data_hora_ultima_carga: '',
        periodicidade_carga: { id: 0, periodicidade: '' },
        orgao_responsavel: { id: 0, orgao: '', sigla: '' },
      },

      termo: null,
      listaPrivilegios: [],
      tabela: {
        data: [],
        campos: [{
          name: 'orgao_responsavel.sigla',
          sortField: 'orgao_responsavel.sigla',
          title: 'Orgão',
          width: '2%',
        },
        {
          name: 'nome_dag',
          sortField: 'nome_dag',
          title: 'DAG',
          width: '22%',
        },
        {
          name: 'periodicidade_carga.periodicidade',
          sortField: 'periodicidade_carga.periodicidade',
          title: 'Periodicidade',
          width: '10%',
        },
        {
          name: 'data_hora_ultima_carga',
          sortField: 'data_hora_ultima_carga',
          title: 'Ulima Carga',
          width: '15%',
        },
        {
          name: '__slot:edicao',
          dataClass: 'action-slot',
          width: '1%',
        },
        {
          name: '__slot:delecao',
          dataClass: 'action-slot',
          width: '1%',
        }],
        sort: {},
        filtro: ['nome'],
        itemsPerPage: 13,
      },

      tabelaDados: {
        data: [],
        campos: [
          {
            name: 'id',
            sortField: 'id',
            title: 'ID',
            width: '1%',
          },
          {
            name: 'carga.nome_dag',
            sortField: 'carga.nome_dag',
            title: 'DAG Carga',
            width: '15%',
          },
          {
            name: 'local_distribuicao',
            sortField: 'local_distribuicao',
            title: 'Local Distribuição',
            width: '20%',
          },
          {
            name: 'nome_arquivo_ultima_importacao',
            sortField: 'nome_arquivo_ultima_importacao',
            title: 'Ultimo Arquivo',
            width: '15%',
          },
          {
            name: 'periodicidade_dado.periodicidade',
            sortField: 'periodicidade_dado.periodicidade',
            title: 'Period.',
            width: '5%',
          },
          {
            name: 'meio_distribuicao.meio_distribuicao',
            sortField: 'meio_distribuicao',
            title: 'Distr.',
            width: '5%',
          },
          {
            name: 'meio_representacao.meio_representacao',
            sortField: 'meio_representacao',
            title: 'Repr.',
            width: '5%',
          },
          {
            name: 'data_arquivo_ultima_importacao',
            sortField: 'data_arquivo_ultima_importacao',
            title: 'Ultima Importação',
            width: '5%',
          },
          {
            name: '__slot:edicao',
            dataClass: 'action-slot',
            title: ' ',
            width: '1%',
          },
          {
            name: '__slot:delecao',
            dataClass: 'action-slot',
            title: ' ',
            width: '1%',
          }],
        sort: {},
        filtro: ['nome'],
        itemsPerPage: 10,
      },

      iframe: { id: 0, nome: '', url: '', privilegio: '' },
      iframes: [],
      linkSel: {},
      cacheList: [],
      options: [],
      isBtnSaveDisabled: true,

      meiosDistribuicao: [],
      meiosRepresentacao: [],
      orgaosResponsaveis: [],
      periodicidade: [],
      cargas: [],

      openCacheModal: false,
      openModalCarga: false,
      openModalDelecao: false,
      openModalRepresentacao: false,
      openModalOrgao: false,
      openModalDistribuicao: false,
      openModalPeriodicidade: false,
      openModalMetadados: false,
    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('cache/buscarCache'),
      this.$store.dispatch('metaDados/GetMeiosDeDistribuicao', 0),
      this.$store.dispatch('metaDados/GetMeiosDeRepresentacao', 0),
      this.$store.dispatch('metaDados/GetOrgaosResponsaveis', 0),
      this.$store.dispatch('metaDados/GetPeriodicidade', 0),
      this.$store.dispatch('metaDados/GetCargas', 0),
      this.$store.dispatch('metaDados/GetDados', 0),
    ])
      .then(
        retorno => {
          console.log(retorno)
          this.cacheList = retorno[0].data
          this.meiosDistribuicao = retorno[1].data.data
          this.meiosRepresentacao = retorno[2].data.data
          this.orgaosResponsaveis = retorno[3].data.data
          this.periodicidade = retorno[4].data.data
          this.cargas = retorno[5].data.data
          this.cargaDados = retorno[6].data.data

          this.tabelaDados.data = this.cargaDados
          this.tabela.data = this.cargas
          this.updateTabela(this.tabela.data)
          this.cacheList = _.orderBy(retorno[0].data, 'nome')
        }
      )
  },

  methods: {
    cancelarDelecao () {
      this.iframeADeletar = {}
    },

    pesquisa: _.debounce(function (term) {
      this.termo = term
      let a = []

      if ((!Number.isNaN(parseInt(term))) && term !== '') {
        a = this.$refs.tabelaUnidade.filterByNumber(this.iframes, this.termo)
      } else {
        a = this.$refs.tabelaUnidade.filterByString(this.iframes, this.termo)
      }

      this.tabela.data = a
      this.updateTabela(this.tabela.data)
    }, 400),

    valida () {
      return this.$validator.validateAll('formIframe').then(valid => {
        return valid
      })
    },

    persiste () {
      event.preventDefault()
      this.valida().then(valido => {
        if (!valido) {
          this.showToast(this.$t('management.incorrectFields'), constantes.TOASTED_ERROR)
        } else {
          if (this.iframe.id === 0) {
            this.$store.dispatch('iframeDashboard/postIframeRetornar', this.iframe)
              .then(retorno => {
                this.showToast(this.$t('management.iframe.forms.nome') + ` ${retorno.data.nome}` + this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
                this.limpar()
                this.tabela.data.push(retorno.data)
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.insertedError'), constantes.TOASTED_ERROR)
              })
          } else {
            this.$store.dispatch('iframeDashboard/putIframe', this.iframe)
              .then(retorno => {
                this.updateLink(this.iframe, index)
                this.showToast(this.$t('management.iframe.forms.nome') + ` ${this.iframe.nome}` + this.$t('management.updated'), constantes.TOASTED_SUCCESS)
                this.limpar()
              })
              .catch(err => {
                console.error(err)
                this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
              })
          }
        }
      })
    },

    updateLink (iframe, index) {
      Vue.set(this.tabela.data, index, iframe)
      this.$refs.tabelaUnidade.resetPage()
    },

    editar (event) {
      if (event) this.editado = _.cloneDeep(event.rowData)
      this.openModalMetadados = !this.openModalMetadados
    },

    editarCarga (event) {
      if (event) {
        let clone = _.cloneDeep(event.rowData)
        this.cargaEditavel = clone
      } else {
        this.cargaEditavel = this.novoOrgaoEditavel
      }
      this.openModalCarga = !this.openModalCarga
    },

    cacheModal () {
      this.openCacheModal = !this.openCacheModal
    },

    deletarModal (event) {
      this.perfilADeletar = event.rowData
      this.openModalDelecao = true
    },

    deletar () {
      this.$store.dispatch('iframeDashboard/deleteIframe', this.iframeADeletar.id)
        .then(
          retorno => {
            this.showToast(this.$t('management.iframe.forms.nome') + ` ${this.iframeADeletar.nome}` + this.$t('management.deleted'), constantes.TOASTED_SUCCESS)
            this.tabela.data = this.tabela.data.filter(uni => {
              return uni.id !== this.iframeADeletar.id
            })
          }
        )
        .catch(err => {
          console.error(err)
          this.showToast(this.$t('management.deletedError'), constantes.TOASTED_ERROR)
        })
    },

    limpar () {
      event.preventDefault()
      this.iframe = UnidadeService.newUnidade()
      this.$validator.reset()
    },

    updateTabela (dados) {
      this.$set(this.tabela, 'data', dados)
    },

    /** Metodos Cache */
    getCache () {
      this.$store.dispatch('cache/buscarCache')
    },

    limparCache (chave) {
      if (chave) {
        this.$store.dispatch('cache/limparChave', chave).then((resposta) => {
          let index = _.findIndex(this.cacheList, c => c.nome === chave)
          let item = this.cacheList[index]
          item.chaves = []
          this.updateTabelaDadosCache(index, item)
        })
      } else {
        this.$store.dispatch('cache/limparCache').then((resposta) => {
          for(let index = 0; index < this.cacheList.length; index++) {
            let item = this.cacheList[index]
            item.chaves = []
            this.updateTabelaDadosCache(index, item)
          }          
        })
      }
    },

    updateTabelaDadosCache (index, chave) {
      Vue.set(this.cacheList, index, chave)
    },

    editarMetadados (el) {
      if (el) this.metadadosEditavel = _.cloneDeep(el)
    },

    /** Edição de Atributos de metadados */
    editarOrgao (el) {
      if (el) this.orgaoEditavel = _.cloneDeep(el)
      this.openModalOrgao = !this.openModalOrgao
    },
    editarPeriodicidade (el) {
      if (el) this.periodicidadeEditavel = _.cloneDeep(el)
      this.openModalPeriodicidade = !this.openModalPeriodicidade
    },
    editarRepresentacao (el) {
      if (el) this.representacaoEditavel = _.cloneDeep(el)
      this.openModalRepresentacao = !this.openModalRepresentacao
    },
    editarDistribuicao (el) {
      if (el) this.distribuicaoEditavel = _.cloneDeep(el)
      this.openModalDistribuicao = !this.openModalDistribuicao
    },
    persistirDistribuicao () {
      if (this.distribuicaoEditavel.id) {
        this.$store.dispatch('metaDados/PutMeiosDeDistribuicao', this.distribuicaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.distribuicaoEditavel, this.distribuicaoEditavel.id, this.meiosDistribuicao)
            this.distribuicaoEditavel = this.novaDistribuicaoEditavel()
          })
          .catch((err) => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostMeiosDeDistribuicao', this.distribuicaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
            this.meiosDistribuicao.push(retorno.data.data.shift())
            this.distribuicaoEditavel = this.novaDistribuicaoEditavel()
          })
          .catch((err) => {
            this.showError(err)
          })
      }
    },
    persisirRepresentacao () {
      if (this.representacaoEditavel.id) {
        this.$store.dispatch('metaDados/PutMeiosDeRepresentacao', this.representacaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.representacaoEditavel, this.representacaoEditavel.id, this.meiosRepresentacao)
            this.representacaoEditavel = this.novaRepresentacaoEditavel()
          })
          .catch((err) => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostMeiosDeRepresentacao', this.representacaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
            this.representacaoEditavel = this.novaRepresentacaoEditavel()
            this.meiosRepresentacao.push(retorno.data.data.shift())
          })
          .catch((err) => {
            this.showError(err)
          })
      }
    },
    persisirPeriodicidade () {
      if (this.periodicidadeEditavel.id) {
        this.$store.dispatch('metaDados/PutPeriodicidade', this.periodicidadeEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.periodicidadeEditavel, this.periodicidadeEditavel.id, this.periodicidade)
            this.periodicidadeEditavel = this.novaPeriodicidadeEditavel()
          })
          .catch(err => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostPeriodicidade', this.periodicidadeEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
            this.periodicidadeEditavel = this.novaPeriodicidadeEditavel()
            this.periodicidade.push(retorno.data.data.shift())
          })
          .catch(err => {
            this.showError(err)
          })
      }
    },
    persistirOrgao () {
      if (this.orgaoEditavel.id) {
        this.$store.dispatch('metaDados/PutOrgaosResponsaveis', this.orgaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.orgaoEditavel, this.orgaoEditavel.id, this.orgaosResponsaveis)
            this.orgaoEditavel = this.novoOrgaoEditavel()
          })
          .catch((err) => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostOrgaosResponsaveis', this.orgaoEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
            this.orgaoEditavel = this.novoOrgaoEditavel()
            this.orgaosResponsaveis.push(retorno.data.data.shift())
          })
          .catch((err) => {
            this.showError(err)
          })
      }
    },
    persistirCarga () {
      if (this.cargaEditavel.id) {
        this.$store.dispatch('metaDados/PutCargas', this.cargaEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.updated'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.cargaEditavel, this.cargaEditavel.id, this.cargas)
            this.cargaEditavel = this.novoCargaEditavel
          })
          .catch((err) => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostCargas', this.cargaEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS) // Refatorar i18n suporta template string ex: 'xyz - {var}'
            this.cargaEditavel = this.novoCargaEditavel
            this.cargas.push(retorno.data.data.shift())
          })
          .catch((err) => {
            this.showError(err)
          })
      }
    },
    persistirMetadados () {
      if (this.metadadosEditavel.id) {
        this.$store.dispatch('metaDados/PutMetadados', this.metadadosEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
            this.updateByKey(this.cargaEditavel, this.cargaEditavel.id, this.cargas)
            this.metadadosEditavel = this.novoCargaEditavel()
          })
          .catch(err => {
            this.showError(err)
          })
      } else {
        this.$store.dispatch('metaDados/PostMetadados', this.metadadosEditavel)
          .then(retorno => {
            this.showToast(this.$t('management.inserted'), constantes.TOASTED_SUCCESS)
            this.cargaDados.push(retorno.data.data.shift())
            this.metadadosEditavel = this.novoCargaEditavel()
          })
          .catch(err => {
            this.showError(err)
          })
      }
    },

    updateByKey (array, element, key) {
      let i = _.findIndex(array, function (o) { return o[key] === element[key] })
      if (i) {
        array[i] = element
      } else {
        throw error(`Elemento ${element[key]} não encontrado no Array fornecido: ${i}`)
      }
    },

    // Novos elementos editaveis
    novaDistribuicaoEditavel: () => { return { id: 0, meio_distribuicao: '' } },
    novaRepresentacaoEditavel: () => { return { id: 0, meio_representacao: '' } },
    novaPeriodicidadeEditavel: () => { return { id: 0, periodicidade: '' } },
    novoOrgaoEditavel: () => { return { id: 0, sigla: '', orgao: '' } },
    novoEditado: () => {
      return { carga: {},
        data_arquivo_ultima_importacao: new Date(),
        data_hora_ultima_importacao: new Date(),
        data_referencia_ultima_importacao: new Date(),
        descricao_dado: '',
        fonte_dado: '',
        formato_nome: '',
        id: 0,
        local_distribuicao: '',
        meio_distribuicao: {},
        meio_representacao: {},
        nome_arquivo_ultima_importacao: '',
        nome_dado: '',
        periodicidade_dado: {},
      }
    },
    novoCargaEditavel: () => {
      return { id: 0,
        nome_dag: '',
        data_hora_ultima_carga: '',
        periodicidade_carga: { id: 0, periodicidade: '' },
        orgao_responsavel: { id: 0, orgao: '', sigla: '' },
      }
    },

    showError (err) {
      console.error(err)
      this.showToast(this.$t('management.updatedError'), constantes.TOASTED_ERROR)
    },
  },
}
</script>

<style lang="scss" scoped>
  .quebra-palavra {
    word-break: break-word;
  }
  .listaCache{
    height: 50rem;
    max-height: 50rem;
    overflow-y: auto;
    overflow-wrap: normal;
  }
  .modalForm{
    width: 30em;
  }
  .listaEdit{
    height: 20rem;
    max-height: 20rem;
    overflow-y: auto;
    overflow-wrap: normal;
  }
  .bold{
    font-weight: bold;
    font-size: 1.2rem;
  }
  .boldLabel{
      bottom: 0.875rem;
      left: 0.5rem;
      margin-bottom: 0.5rem;
      max-width: calc(100% - 0.25rem);
      color: $brand-success;
      font-size: 0.825rem;
      letter-spacing: 0.0375rem;
      line-height: 1.2;
      font-weight: bold;
      text-transform: uppercase;
  }

  .multiselect__label{
    bottom: 0.875rem;
    left: 0.5rem;
    margin-bottom: 0.5rem;
    max-width: calc(100% - 0.25rem);
    color: #4ae387;
    font-size: 0.625rem;
    letter-spacing: 0.0375rem;
    line-height: 1.2;
    font-weight: bold;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    -webkit-transform-origin: top left;
    transform-origin: top left;
  }
  .baseline-align{
            display: flex;
            align-items: center;
            //justify-content: center;
            flex-direction: row;
            //text-align: center;

  }
</style>
<style lang="scss" >
  .multiselect__placeholder {
    color: $brand-success;
  }
  .multiselect--active {
    z-index: 20 !important;
    position: relative;
  }
  .multiselect__content-wrapper{
    z-index: 20
  }
</style>
